import { computed, ref } from "@vue/composition-api";
import { Loader, LoaderOptions } from "@googlemaps/js-api-loader";

export default function () {
    //old const apiKey = "AIzaSyCy9LGBG3lKJ921_x93_rz9y0UO0IodssM";
    const apiKey = "AIzaSyApxk3D-krEwWwILQYfCz7loR-wVj8wLZQ";
    //const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
    const options = ref<LoaderOptions>({
        apiKey: apiKey,
        libraries: ["geometry"],
    });
    const googleMapApi = new Loader(options.value);
    return { googleMapApi };
}